import { Controller } from "@hotwired/stimulus"

// Series filter — toggles group buckets on the annual wheel by clicking a
// group chip. Pure DOM manipulation, no turbo/fetch. Syncs `?group=` in the
// URL so selections are shareable.
//
// Expected markup:
//   <div data-controller="series-filter">
//     <button data-group="all" data-action="click->series-filter#filter" class="group-chip group-chip--active">…</button>
//     <button data-group="winter" data-action="click->series-filter#filter" class="group-chip">…</button>
//     …
//     <section data-group-bucket="winter">…</section>
//   </div>
export default class extends Controller {
  connect() {
    const params = new URLSearchParams(window.location.search)
    const requested = params.get("group")
    if (requested) {
      const chip = this.element.querySelector(`[data-group="${requested}"]`)
      if (chip) this._activate(chip)
    }
  }

  filter(event) {
    this._activate(event.currentTarget)
  }

  _activate(chip) {
    const group = chip.dataset.group
    this.element
      .querySelectorAll(".group-chip")
      .forEach((c) => c.classList.toggle("group-chip--active", c === chip))
    this.element.querySelectorAll("[data-group-bucket]").forEach((bucket) => {
      const match = group === "all" || bucket.dataset.groupBucket === group
      bucket.style.display = match ? "" : "none"
    })
    const url = new URL(window.location.href)
    if (group === "all") {
      url.searchParams.delete("group")
    } else {
      url.searchParams.set("group", group)
    }
    window.history.replaceState({}, "", url.toString())
  }
}
